import FulfillingMoment from 'components/display/FulfillingMoment'
import { Image, Moment } from '../styles'

const ImageGrid = () => {
  return (
    <Image>
      <div>
        <Moment>
          <FulfillingMoment momentName="peacefulness" />
        </Moment>
      </div>
      <div>
        <Moment>
          <FulfillingMoment momentName="rejuvenation" />
        </Moment>
        <Moment>
          <FulfillingMoment momentName="slowness" />
        </Moment>
      </div>
      <div>
        <Moment>
          <FulfillingMoment momentName="challenge" />
        </Moment>
        <Moment>
          <FulfillingMoment momentName="joy" />
        </Moment>
      </div>
      <div>
        <Moment>
          <FulfillingMoment momentName="unplugged" />
        </Moment>
        <Moment>
          <FulfillingMoment momentName="groundedness" />
        </Moment>
        <Moment>
          <FulfillingMoment momentName="freedom" />
        </Moment>
      </div>
    </Image>
  )
}

export default ImageGrid
